import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import { selectPartnerTechnicalNameById } from '../../../globals/state/selector'
import {
    ALIGNER_SYSTEM_LIST_FULL,
    ALIGNER_SYSTEM_LIST_HAT_GROUP,
    SUPPLIER_TECHNICAL_NAME_HAT_GROUP,
} from '../../../treatment/state/quotation/const'

export const selectCustomerDetailState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectOwnState = (state) => {
    return selectCustomerDetailState(state)[REDUCER_NAME]
}

export const selectIsFetching = (state) => {
    return selectOwnState(state).fetching
}

export const selectTab = state => {
    return selectOwnState(state).tab
}

export const selectImageFetching = state => {
    return selectOwnState(state).imageFetching
}

export const selectChangeEmailData = state => {
    return selectOwnState(state).changeEmailData
}

export const selectStartProcessFetching = state => {
    return selectOwnState(state).startProcessFetching
}

export const selectHasChanged = state => {
    return selectOwnState(state).hasChanged
}

export const selectCustomer = state => {
    return selectOwnState(state).customer
}

export const selectTreatmentAlignerSystemList = state => {
    const customer = selectCustomer(state)
    const supplierTechnicalName = selectPartnerTechnicalNameById(state, customer.partnerSupplierId)
    return supplierTechnicalName === SUPPLIER_TECHNICAL_NAME_HAT_GROUP ? ALIGNER_SYSTEM_LIST_HAT_GROUP : ALIGNER_SYSTEM_LIST_FULL
}

export const selectIsExternalTreatmentPlanerPossible = state => {
    const customer = selectCustomer(state)
    if (!customer || !customer.partnerSupplierId) {
        return false
    }
    const technicalName = selectPartnerTechnicalNameById(state, customer.partnerSupplierId)
    return technicalName === 'sunshine_smile'
}

export const selectAccountFix = state => {
    return selectOwnState(state).accountFix
}

export const selectCustomerId = state => {
    const customer = selectCustomer(state)
    return customer ? customer.id : null
}

export const selectTreatmentExpectation = state => {
    const customer = selectCustomer(state)
    return customer ? customer.treatmentExpectation : null
}

export const selectMedicalCondition = state => {
    const customer = selectCustomer(state)
    return customer ? customer.medicalCondition : null
}

export const selectImageList = state => {
    const customer = selectCustomer(state)
    return customer ? customer.imageList : []
}

export const selectShowImages = state => {
    return selectOwnState(state).showImages
}

export const selectProcessList = state => {
    const customer = selectCustomer(state)
    return customer ? customer.processList : null
}

export const selectResponseFeedback = state => {
    return selectOwnState(state).responseFeedback
}

export const selectDeleteConfirmationModal = state => {
    return selectOwnState(state).deleteConfirmationModal
}

export const selectCustomerContact = state => {
    return selectOwnState(state).contact
}

export const selectCustomerError = state => {
    return selectOwnState(state).error
}



// WEBPACK FOOTER //
// ./src/modules/customer/state/detail/selector.js